<template>
  <v-layout>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <!-- <v-flex xs12 d-flex text-xs-center>
                <h1>Üdvözlünk a skillers rendszerben!</h1>
          </v-flex> -->

        <StepField />
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
import StepField from "@/components/StepField";

export default {
  components: {
    StepField
  },
  computed: {},
  data: () => ({}),
  methods: {}
};
</script>

<style></style>
